import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-expense-ai-category',
  templateUrl: './expense-ai-category.component.html',
  styleUrls: ['./expense-ai-category.component.scss']
})
export class ExpenseAiCategoryComponent {
  @Input() categoryName: string;
  @Input() hasAiData: boolean = false;
  @Input() matches: boolean = false;
  @Input() mismatchReason: string;
}
